export default __webpack_public_path__ + "static/media/Tesso's Glory.477f2c81.jpg";